/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Tr_2_AInputs */

const en_mk_tut_tr_2_a = /** @type {(inputs: Mk_Tut_Tr_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That is the correct behaviour — it refuses to invent things. Add the missing material to the issue description (figures, product names, recipients) and ask it to redo the work in a comment.`)
};

const id_mk_tut_tr_2_a = /** @type {(inputs: Mk_Tut_Tr_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itu perilaku yang benar — ia menolak mengarang. Tambahkan bahan yang kurang ke deskripsi issue (angka, nama menu, penerima), lalu minta ia mengerjakan ulang lewat komentar.`)
};

/**
* | output |
* | --- |
* | "That is the correct behaviour — it refuses to invent things. Add the missing material to the issue description (figures, product names, recipients) and ask i..." |
*
* @param {Mk_Tut_Tr_2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_tr_2_a = /** @type {((inputs?: Mk_Tut_Tr_2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Tr_2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_tr_2_a(inputs)
	return en_mk_tut_tr_2_a(inputs)
});